(ns common.schema.entities.survey-reminder.schema
  (:require
   [common.schema.entities.survey-reminder.options :as options]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/single-ref-field :survey-reminder/reminder-rule
                         "Reminder rule"
                         [:entity.type/reminder-rule]
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use-disabled})
    (su/datetime-field :survey-reminder/scheduled-at
                       "Scheduled at"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    (su/datetime-field :survey-reminder/sent-at
                       "Sent at"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled})
    (su/keyword-field :survey-reminder/reminder-status
                      "Status"
                      options/reminder-status-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/text-simple-field :survey-reminder/reminder-status-reason
                          "Status reason"
                          {:authorization            su/access-user-user
                           :default-field-visibility :in-use-disabled}))))
